const initCmpTrigger = () => {
    const cmpButton = document.querySelector('.show-cmp-overlay a');

    if (cmpButton) {
        cmpButton.addEventListener('click', (ev) => {
            ev.preventDefault();

            if (typeof __cmp === "function") {
                __cmp('showScreenAdvanced')
            }
        })

    }
}
document.addEventListener('DOMContentLoaded', function () {
    initCmpTrigger();
    // Nur auf Geräten ohne Hover-Fähigkeit (Touchgeräte)
    const isTouchOnly = window.matchMedia('(hover: none)').matches;

    if (isTouchOnly) {
        document.querySelectorAll('.first-level > a').forEach(link => {
            link.addEventListener('click', function (e) {
                e.preventDefault(); // Klick deaktivieren
            });
        });
    }
});